module.exports = class ArchivableMixin

  # it is important to look for { closed: false } on
  # models that can be archived because sometimes, the
  # client receives partial data about a board, card,
  # or list that does not contain its { closed } state.
  # in those cases, our previous check -- !@get('closed')
  # -- would return undefined, which we wanted to interpret
  # as being closed but were not correctly doing so in all places.
  # explicitly checking for { closed: false } is therefore correct.

  isOpen: ->
    @get('closed') == false





// WEBPACK FOOTER //
// ./app/scripts/lib/archivable-mixin.coffee